<template>
  <div>
    <el-row>
      <el-col :lg="{span:24}" :xl="{span:24}" :md="{span:24}">
        <el-table class="dashboard-table"
                  show-summary
                  :summary-method="getSummaries"
                  :data="customData"
                  style="width: 100%">
          <el-table-column :prop="rowName" :label="tableName" align="center" header-align="center">
            <template slot-scope="scope">
              <el-link v-if="rowName==='platform_name'" type="primary" style="font-size: 12px"
                       @click="toDetail(scope.row)">
                {{ scope.row[rowName] }}
                <!--                <span v-if="scope.row.platform_other_names">({{ scope.row.platform_other_names.join('、') }})</span>-->
              </el-link>
              <span v-else>{{ scope.row[rowName] || '' }}</span>
            </template>
          </el-table-column>
          <el-table-column align="right" prop="total" label="合计" sortable>
            <template v-slot="{row:{total}}">
              {{ total|numberFormat }}
            </template>
          </el-table-column>
          <el-table-column align="right" prop="yoy_growth_rate" label="同比" sortable>
            <template v-slot="{row:{yoy_growth_rate}}">
              <span :class="parseFloat(yoy_growth_rate) > 0 ? 'growth-red' : (parseFloat(yoy_growth_rate) < 0 ? 'reduce-green' : '')">
                {{ yoy_growth_rate|numberFormat(2) }}%
              </span>
            </template>
          </el-table-column>
          <el-table-column v-for="(item,index) in monthMap" align="right"
                           :prop="index"
                           :key="index"
                           v-bind:label="item"
                           sortable
          >
            <template slot-scope="scope">
              {{ scope.row[index]|numberFormat }}
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :lg="{span:24}" :xl="{span:24}" :md="{span:24}" style="padding-top: 15px">
        <div :id="chartId" style="width: 100%;height: 450px"/>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import * as echarts from 'echarts';
import _ from 'lodash'

let monthMap = {};
for (let i = 1; i <= 12; i++) {
  monthMap[i + '-month'] = i + '月'
}
export default {
  name: "brandAmountTableAndChart",
  props: {
    data: [Array],
    chartData: [Array],
    chartLegend: [Array],
    chartId: [String],
    tableName: [String],
    rowName: {
      type: String,
      default: 'platform_name',
    },
    year: [String, Number],
    organizationId: [String, Number, Boolean],
  },
  data() {
    return {
      monthMap,
      customData: this.dealData(),
      customChartData: this.chartData,
      customChartLegend: this.chartLegend,
      customChartYearData: 0,
    }
  },
  watch: {
    data: function () {
      this.customData = this.dealData()
    },
    chartData: function (value) {
      this.customChartData = value || []
      this.chartYear()
      this.initData()
    },
    chartLegend: function (value) {
      this.customChartLegend = value || []
      this.initData()
    }
  },

  methods: {
    dealData: function () {
      const table = []
      this.data.map(function (item) {
        const row = item
        row.total = 0
        for (let i = 1; i <= 12; i++) {
          if (row[i + '-month'] === undefined) {
            row[i + '-month'] = 0
          }
          row.total = row.total + row[i + '-month']
        }
        table.push(row)
      })
      return table
    },
    chartYear: function () {
      // this.initData()
      let newData = []
      this.data.forEach((item) => {
        let AllCount = {
          name: item.platform_name,
          value: 0
        }
        _.forEach(item, function (value, key) {
          if (key.includes('month')) {
            AllCount.value = AllCount.value + item[key]
          }
        });
        newData.push(AllCount)
        //
      })
      // console.log(newData)
      this.customChartYearData = newData
    },
    initData() {
      this.initChart(this.customChartData || [], this.customChartLegend, this.customChartYearData)
    },
    getSummaries(param) {
      const {columns, data} = param
      let total = 0;
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计:'
          return
        }
        const columns = Object.keys(this.monthMap)
        columns.push('total')
        columns.push('yoy_growth_rate')
        if (columns.indexOf(column.property) > -1) {
          const values = data.map(item => Number(item[column.property === 'yoy_growth_rate' ? 'yoy_growth_rate_money' : column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev * 1 + curr * 1
              } else {
                return prev
              }
            }, 0)
            if (['total', 'yoy_growth_rate'].includes(column.property)) {
              if (column.property === 'total') {
                total = sums[index]
              } else {
                sums[index] = Math.floor((total - sums[index]) / sums[index] * 10000 + 0.5) / 100
              }
            }
            sums[index] += ''
          } else {
            sums[index] = 'N/A'
          }
          if (column.property === 'yoy_growth_rate') {
            sums[index] = this.gFunc.numberFormat(sums[index], 2) + '%'
          } else {
            sums[index] = this.gFunc.numberFormat(sums[index])
          }
        }
      });
      // 返回
      return sums
    },
    toDetail(row) {
      const {href} = this.$router.resolve({
        name: `homePlatformDetail`,
        query: {
          platformName: row.platform_name,
          year: this.year,
          organization_id: this.organizationId,
          platformCode: row.platform_code,
        }
      });
      window.open(href, "_blank");
    },
    initChart(source, legendData, yearData, domId = false,) {
      const length = legendData.length
      domId = domId ? domId : this.chartId;
      if (length < 1) {
        return false;
      }
      let series = [];
      const seriesLineObj = {type: 'line', smooth: true, seriesLayoutBy: 'row', emphasis: {focus: 'series'}};
      const seriesPieObj = {
        type: 'pie',
        id: 'pie',
        radius: '30%',
        height: '100%',
        center: ['30%', '50%'],
        emphasis: {focus: 'data'},
        label: {
          formatter: '{b}: {@1月} ({d}%)'
        },
        encode: {
          itemName: '月份',
          value: '1月',
          tooltip: '1月'
        }
      };
      const seriesPieObjYear = {
        type: 'pie',
        id: 'pieYear',
        radius: '30%',
        center: ['10%', '50%'],
        height: '100%',
        emphasis: {focus: 'data'},
        label: {
          formatter: '{b}: {@1月} ({d}%)'
        },
        encode: {
          itemName: '月份',
          value: '1月',
          tooltip: '1月'
        },
        data: yearData,
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: 'rgba(0, 0, 0, 0.5)'
        }
      };
      for (let i = 0; i < legendData.length - 1; i++) {
        series.push(seriesLineObj)
      }
      series.push(seriesPieObj);
      series.push(seriesPieObjYear);

      this.$nextTick(function () {
        let myChart = echarts.init(document.getElementById(domId));
        let option = {
          legend: {},
          padding: ['10%'],
          tooltip: {
            trigger: 'axis',
            showContent: false
          },
          dataset: {
            source: source
          },
          xAxis: {type: 'category'},
          yAxis: {gridIndex: 0},
          grid: {left: '50%'},
          series: series
        };

        myChart.on('updateAxisPointer', function (event) {
          const xAxisInfo = event.axesInfo[0];
          if (xAxisInfo) {
            const dimension = xAxisInfo.value + 1;
            myChart.setOption({
              series: {
                id: 'pie',
                label: {
                  formatter: '{b}: {@[' + dimension + ']} ({d}%)'
                },
                encode: {
                  value: dimension,
                  tooltip: dimension
                }
              }
            });
          }
        });

        myChart.setOption(option);
      });
    }
  }
}
</script>

<style scoped>
.growth-red {
  color: rgb(255, 36, 54);
}

.reduce-green {
  color: rgb(7, 171, 75);
}

.normal-def {
  color: #606266;
}
</style>
